import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var StyledNeutralBadge = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  padding: 2px ", ";\n  align-items: flex-start;\n  gap: 10px;\n  border-radius: 20px;\n  background: ", ";\n\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n  letter-spacing: 0.1px;\n"], ["\n  display: flex;\n  padding: 2px ", ";\n  align-items: flex-start;\n  gap: 10px;\n  border-radius: 20px;\n  background: ", ";\n\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n  letter-spacing: 0.1px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.lightest;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.darker;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map